import React from 'react';
import { t } from '../i18n';

const StatCard = ({
  title = '',
  value = '',
  subtitle = '',
  icon: Icon = null,
  trend = '',
  trendPositive = true,
  onClick = null,
  selected = false
}) => {
  const interactive = typeof onClick === 'function';

  const handleKeyDown = (event) => {
    if (!interactive) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <div
      className={`bg-white rounded border p-3 ${
        selected ? 'border-brand-400 bg-brand-50' : 'border-neutral-200'
      } ${interactive ? 'cursor-pointer hover:border-neutral-300 focus:outline-none focus:ring-1 focus:ring-brand-400' : ''}`}
      role={interactive ? 'button' : undefined}
      tabIndex={interactive ? 0 : undefined}
      onClick={interactive ? onClick : undefined}
      onKeyDown={handleKeyDown}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="flex-1 min-w-0">
          <p className="text-neutral-500 font-medium text-xs mb-1 truncate">{t(title)}</p>
          <h3 className="num text-left text-xl font-semibold text-neutral-900 leading-none mb-1">{t(value)}</h3>
          {subtitle && (
            <p className="text-neutral-500 text-xs">{t(subtitle)}</p>
          )}
          {trend && (
            <p
              className={`mt-1.5 text-xs font-medium ${
                trendPositive ? 'text-success-600' : 'text-danger-600'
              }`}
            >
              {t(trend)}
            </p>
          )}
        </div>

        {Icon && <Icon className="w-4 h-4 text-neutral-400 shrink-0" />}
      </div>
    </div>
  );
};

export default StatCard;
